<script>
  import {previewUrlForVideo} from "./services/imageService";
  import {normalized_video_store, video_store} from "./Utils/stores";
  import {update_video_category} from "./Utils/RouterUtils.svelte";

  export let video = null
  $: related = filterRelatedVideos(video);

  function filterRelatedVideos(video) {
    if (!video || !video.relatedVideos) {
      return []
    }
    return video.relatedVideos.filter(v => $normalized_video_store.videos[v.slug.current]);
  }

  /**
   * @param{string} video_slug
   */
  function update_video_and_category(video_slug) {
    console.log("Updating the video to " + video_slug)
    const video = $normalized_video_store.videos[video_slug];
    if (video.category.length < 1) {
      console.warn("Expect each video to be part of a category")
      return;
    }
    const category_id = video.category[0].category._ref;
    let found_category = $video_store.categories.find(c => c._id === category_id);
    if (!found_category) {
      console.warn("Expected to find the category")
      return;
    }
    if (found_category) {
      console.log(`Found category is : ${found_category.slug.current}`)
      update_video_category(video_slug, found_category.slug.current);
    }
  }

</script>

{#if related.length > 0}

<div class="vec-bg-lightGrey vec-pt-5 md:vec-pt-10 md:vec-pr-[32.5%]">
      <h4 class="vec-px-5 md:vec-px-10 vec-mb-2">Related Videos</h4>
      <div class="vec-flex vec-overflow-x-auto vec-px-5 md:vec-px-10">
        {#each related as related_video (related._id)}
          <div class="vec-w-1/2 sm:vec-w-1/3 md:vec-w-1/4 vec-mr-8 vec-flex-shrink-0 vec-cursor-pointer"
               on:click={update_video_and_category(related_video.slug.current)}>
              <div class="vec-w-full vec-aspect-[16/9] vec-overflow-hidden vec-rounded-lg vec-rounded-bl-none vec-text-sm vec-mb-2 vec-border vec-border-midGrey">
                <img src={previewUrlForVideo($normalized_video_store.videos[related_video.slug.current])}
                     class="vec-object-contain" style=""
                     alt={related_video.videoTitle}>
              </div>
                <p class="vec-font-bold vec-text-sm vec-mb-5">{related_video.videoTitle}</p>
            </div>
        {/each}
      </div>
</div>
{/if}
<!--<ShareThisVideoView video={video}/>-->
